var _defs, _path, _path2, _circle, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10340IconServiceAzureAdRolesAndAdministrators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ed8fbe5c-618b-47ce-8d68-3dbd1e10f81a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e78519cd-36d2-4ee5-987f-be84be24d95e",
    x1: 7.93,
    y1: 17.95,
    x2: 7.93,
    y2: 5.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4ec36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac3f95ec-6391-4f34-b431-9534d4cdf013",
    x1: 7.95,
    y1: 9.21,
    x2: 7.95,
    y2: -2.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4ec36"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,16.85a1.3,1.3,0,0,0,1.32-1.31.81.81,0,0,0,0-.16c-.52-4.15-2.88-7.53-7.4-7.53S1,10.71.51,15.39A1.34,1.34,0,0,0,1.7,16.85H14Z",
    fill: "url(#e78519cd-36d2-4ee5-987f-be84be24d95e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8.83a4.16,4.16,0,0,1-2.26-.66L7.92,14l2.22-5.79A4.2,4.2,0,0,1,8,8.83Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.95,
    cy: 4.67,
    r: 4.17,
    fill: "url(#ac3f95ec-6391-4f34-b431-9534d4cdf013)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.49 11.13 17.49 15.37 13.85 17.5 13.85 13.26 17.49 11.13",
    fill: "#32bedd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.49 11.13 13.85 13.26 10.21 11.13 13.85 9 17.49 11.13",
    fill: "#9cebff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.85 13.26 13.85 17.5 10.21 15.37 10.21 11.13 13.85 13.26",
    fill: "#50e6ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.21 15.37 13.85 13.26 13.85 17.5 10.21 15.37",
    fill: "#9cebff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.49 15.37 13.85 13.26 13.85 17.5 17.49 15.37",
    fill: "#50e6ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10340IconServiceAzureAdRolesAndAdministrators);
export default __webpack_public_path__ + "static/media/10340-icon-service-Azure-AD-Roles-and-Administrators.52fc699b1891c78f4d23e75ac2a9c4aa.svg";
export { ForwardRef as ReactComponent };